import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { info } from '@root/modules/Sellers/Product/interfaces/index';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Card } from 'antd';
import { useState } from 'react';

const WarehouseInfo = ({ info }: info) => {
  const [isMore, setIsMore] = useState(false);

  return (
    <Card className="card-container">
      {!!info?.name && (
        <div className="card-basic">
          <div className="info-basic">
            <div className="image-warehouse">
              <img src={info?.images[0]?.url ?? "/images/pen.jpg"} />
            </div>
            <div className="info-container">
              <div className="info-center">
                <div className="info-item-1">
                  <div style={{width: '50%', float: 'left'}}>{info.name}</div>
                  <div style={{width: '50%', float: 'right', borderLeft: "1px solid #f0f0f0", paddingLeft: '30px'}}>계약 일자</div>
                </div>
              </div>
              <div>
                <div style={{width: '50%', float: 'left'}}>{info.country}</div>
                <div style={{width: '50%', float: 'right', borderLeft: "1px solid #f0f0f0", paddingLeft: '30px'}}>
                  {formatDateTime(info?.quotations[info?.quotations?.length - 1]?.warehouseApprovedDate, {dateOnly: true})}　
                </div>
              </div>
              <div>{info.address ?? info.detailAddress}</div>
              <div>
                {info.scaleArea &&<span>
                  <strong>규모/면적 &ensp;</strong>
                  <span className="value-info">{info.scaleArea}</span> &emsp;
                  &ensp;
                </span>}
                <span>
                  <strong>특수화물 보관 &ensp;</strong>
                  <span className="value-info">
                    {!!info.specialCargoStorage ? 'Yes' : 'No'}
                  </span>{' '}
                  &emsp;
                </span>
                {info.mainProduct &&<span>
                  <strong>주요 취급상품 &ensp;</strong>
                  <span className="value-info">{info.mainProduct}</span>
                </span>}
              </div>
              {!!isMore && (
                <div className="info-description">
                  <div>상세 설명</div>
                  <div>{info.description}</div>
                </div>
              )}
            </div>
          </div>
          <div className="info-more">
            {!isMore ? (
              <DownOutlined
                onClick={() => {
                  setIsMore(!isMore);
                }}
              />
            ) : (
              <UpOutlined
                onClick={() => {
                  setIsMore(!isMore);
                }}
              />
            )}
          </div>
        </div>
      )}
    </Card>
  );
};

export default WarehouseInfo;
